
function clickGridTable(that){
	that.parents('table').find('.hover').removeClass('hover');
	that.addClass('hover');
	var parent=that.parent('tr').find('td.col1').addClass('hover');
	that.parents('table').find('th').eq(that.data('i')).addClass('hover');
	if(that.find('input').length && !that.find('input:checked').length){
		that.find('input:checked')[0].click();
	}
}
function roundEuro(i){
	var tmp=Math.floor(i*1000);
	var mod=tmp%10;
	if(mod==0){
		i=Math.ceil(i*100)/100;
	}else if(mod<6){
		i=Math.floor(i*100)/100;
	}else {
		i=Math.ceil(i*100)/100;
	}
	return i;
}
function price(i){
	i=roundEuro(i)+'';
	i=i.replace('.',',');
	if(i.indexOf(',') == i.length-2 && i.indexOf(',')>-1)i+='0';
	i+=' zł';
	return i;
}
function setSelectedInterval(position) {
	$('#selected_interval').val(position);
}

function changeDeliveryType() {

	if (checkValues()) {
		$('.order_navigate').removeClass('error error2');
		$('.delivery-type-list').removeClass('statusError');
		incBacks();
		loadingStart();
		$('#F_ACTION').val('CHANGE_DELIVERY_TYPE');
		$('#cartForm')[0].submit();
	}
}

function deliveryTypeListInit(){
	var id,
		element,
		item_checked = $('.delivery-type-list .item.item-checked');

	function showActiveElement() {
		var active_element = $('.delivery-type-list .item.item-checked'),
			id = active_element.find('input[type="radio"]').val();

		$('.delivery-descriptions .descr-item').hide();
		$('.delivery-descriptions .item-'+id).addClass('item-checked').show();
		listItemReady();
	}
	function isRadioChecked(element) {
		return element.find('input[type="radio"]').attr('checked');
	}
	function showSmallActiveElemenet(element, action) {
		if(isRadioChecked(element) != 0) {
			if (action == 'add') {
				element.addClass('item-checked-not-hovered');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-hovered');
			}
		} else {
			if (action == 'add') {
				element.addClass('item-checked-not-default');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-default');
			}
		}
	}
	function listItemReady(){
		if ($('.delivery-type-list').length > 0) {
			var deliveryMenuHeight = $('.delivery-type-list .menu-delivery').outerHeight();
			var deliveryTabHeight = $('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').outerHeight();
			if (deliveryTabHeight < deliveryMenuHeight) {
				$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').height(deliveryMenuHeight-14).addClass('item-ready');
			}
			$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').addClass('item-ready');
		}
	}
	listItemReady();
	$('.delivery-type-list .item').not('.item-checked').hover(function() {
		var $this = $(this);

		$this.addClass('item-hovered');
		id = $this.find('input[type="radio"]').val();
		element = $('.delivery-descriptions .item-'+id).addClass('item-hovered');

		$('.delivery-descriptions .descr-item').hide();
		element.show();

		listItemReady();

		showSmallActiveElemenet(item_checked, 'add');
	}, function() {
		$(this).removeClass('item-hovered');
		if(element){
			element.removeClass('item-hovered');
		}

		item_checked.removeClass('item-checked-not-hovered');

		showActiveElement();

		showSmallActiveElemenet(item_checked, 'remove');
	});
	$('.delivery-type-list .item').click(function(){
		var input=$(this).find('input[name="deliveryType"]');
		if(!input.is(':disabled')){
			input.prop('checked',true)[0].click();
		}
	});
}



function calculateCart() {
	if (checkValues()) {
		$('.order_navigate').removeClass('error error2');
		$('.payment-type-list').removeClass('statusError');
		incBacks();
		loadingStart();
		$('#F_ACTION').val('SAVE');
		removeValidate();
		$('#cartForm')[0].submit();
	}
}


function frontLoginValidate(){		//pgrzech - validacja formularza logowania Rejestracji
	$('#j_username, #j_password, #captcha').keyup(function (event) {
		if(event.keyCode == 13){
			zaloguj();
		}
	});
	fancyRegulamin();
	$("#loginForm").validate({
		rules:{
			j_username: {
				required:true,
				trim:true
			},
			j_password: {
				required:true,
				minlength: 5
			},
			captcha:{
				required:true
			}

		},
		messages:{
			j_username: {
				required:'Podaj login(e-mail)',
				trim:'Pole nie może zawierać spacji'
			},
			j_password: {
				required:'Podaj hasło',
				minlength: 'Hasło jest za krótkie'
			},
			captcha:{
				required:'Podaj tekst z obrazka'
			}
		}
	});
	$('#regAck').click(function(){
		setTimeout(function(){
			$("#registerForm").validate().element('#regAck');
		},100);
	});
	passwordInvalid.init($('#password'), $('#password').parents().find('.password-invalid'), $('#password').closest('.row'), $('#email'));
	$("#registerForm").validate({
		rules:{
			firstname: {
				required: true,
				minlength: 2,
				firstname: true
			},
			surname: {
				required: true,
				minlength: 2,
				surname: true
			},
			password: {
				strongPassword: true
			},
			password2:{
				required: true,
				equalTo: "#password"
			},
			email:{
				required: true,
				email: true
			},
			statuteAccepted: "required"
		},
		messages:{
			firstname: {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			surname: {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			password:{
				required: 'Podaj hasło',
				minlength: 'Hasło musi mieć co najmniej {0} znaków',
				trim: 'Hasło jest niepoprawne'
			},
			password2:{
				required: 'Powtórz hasło',
				equalTo: 'Hasła muszą być identyczne'
			},
			//email weryfikowany JSON'em patrz jquery.validate.js validateEmail(mail)
			email:{
				required: 'Podaj adres e-mail',
				email: 'Podaj poprawny adres e-mail'
			},
			statuteAccepted: 'Akceptacja Regulaminu jest wymagana'
		}
	});
	smallBasketBreakPrice();
}


function deliveryValidate(){

	$('#frontForm').validate({
		rules: {
			"orderUser.email": {
				email:true,
				required:true
			},
			"orderUser.firstname": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"orderUser.surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"receiver.firstName": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"invoice.firstName": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"orderUser.account.password2":{
				required:true,
				minlength: 6,
				equalTo:'#password'
			},
			"orderUser.account.password":{
				required:true,
				minlength: 6,
				trim: true
			},
			"receiver.surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"invoice.surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"orderUser.account.userName":"required",
			"termsAccepted": "required",
			"orderUser.homeAddress.street": {
				required: true,
				minlength: 2,
				maxlength: 60,
				ulica: true
			},
			"orderUser.homeAddress.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"orderUser.homeAddress.flatNumber": {
				maxlength: 10,
				flat: true
			},
			"orderUser.homeAddress.zipCode": "required",
			"orderUser.homeAddress.city": {
				required: true,
				minlength: 2,
				maxlength: 40,
				city: true,
				trim: true
			},
			"insurance.pesel": {
				required: true,
				pesel: true
			},
			"orderUser.companyName": {
				required: true,
				maxlength: 160,
				companyName: true
			},
			"orderUser.nip": {
				nip: true
			},
			"orderUser.phone":{
				phone: true,
				required: true
			},
			"receiver.phone": {
				phone: true,
				required: true
			},
			"deliveryAddress.street": {
				required: true,
				minlength: 2,
				maxlength: 60,
				ulica:true
			},
			"deliveryAddress.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"deliveryAddress.flatNumber": {
				maxlength: 10,
				flat: true
			},
			"deliveryAddress.zipCode": "required",
			"deliveryAddress.city":{
				required: true,
				minlength: 2,
				maxlength: 40,
				city: true,
				trim: true
			},
			"delivery.localization": {
				required: true
			},
			"delivery.parcelMachineCode": {
				required: true
			},
			"delivery.pickupPointForm.dhlParcelPointCode": {
				required: true
			},
			"delivery.pickupPointForm.postOfficeCode": {
				required: true
			},
			"invoice.companyName": {
				required: true,
				maxlength: 160,
				companyName: true
			},
			"invoice.nip":"nip",
			"invoice.street": {
				required: true,
				minlength: 2,
				maxlength: 60,
				ulica: true
			},
			"invoice.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"invoice.flatNumber": {
				maxlength: 10,
				flat: true
			},
			"invoice.zipCode":"required",
			"invoice.city":{
				required: true,
				minlength: 2,
				maxlength: 40,
				city: true,
				trim: true
			},
			"warrantyRegulationsReaded":"required",
			"delivery.shopCode":{
				required: true,
				minlength:2
			},
			"delivery.cityCode":{
				required: true,
				min:1
			},
			"termsAccepted":{
				required: true
			},
			"partnerSubscriptionsContactDetails.termsAccepted":"required",
			"partnerSubscriptionsContactDetails.firstName":{
				minlength: 2,
				required: true,
				firstname: true
			},
			"partnerSubscriptionsContactDetails.lastName":{
				minlength: 2,
				required: true,
				surname: true
			},
			"partnerSubscriptionsContactDetails.contactPhone":{
				required: true,
				phone: true
			}
		},
		messages: {
			"orderUser.email": {
				required: "Podaj adres Email"
			},
			"orderUser.firstname": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"receiver.firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"receiver.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"invoice.firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"invoice.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"orderUser.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"orderUser.account.password":{
				required:"Podaj hasło",
				minlength: "Podaj co najmniej 6 znaków",
				trim: 'Pole nie może być wypełnione tylko spacjami'
			},
			"orderUser.account.password2":{
				required:"Powtórz hasło",
				minlength: "Podaj co najmniej 6 znaków",
				equalTo:"Hasła nie są identyczne"
			},
			"orderUser.account.userName":"Podaj login",
			"termsAccepted": "Akceptacja Regulaminu jest wymagana",
			"orderUser.homeAddress.street": {
				required: "Podaj ulicę",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków",
				ulica: "Format ulicy jest niepoprawny"
			},
			"orderUser.homeAddress.houseNumber": {
				required: "Podaj numer domu",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"orderUser.homeAddress.flat": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"orderUser.homeAddress.zipCode": {
				required:"Podaj kod pocztowy"
			},
			"orderUser.homeAddress.city": {
				required: "Podaj nazwę miejscowości",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"orderUser.phone": {
				minlength: "Podaj numer telefonu",
				required: "Podaj poprawny numer telefonu"
			},
			"receiver.phone": {
				minlength: "Podaj numer telefonu",
				required: "Podaj poprawny numer telefonu"
			},
			"orderUser.companyName": {
				required: "Podaj nazwę firmy",
				maxlength: "Pole może zawierać maksymalnie 160 znaków"
			},
			"insurance.pesel": {
				required: "Podaj numer PESEL"
			},
			"deliveryAddress.street": {
				required: "Podaj nazwę ulicy",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"deliveryAddress.houseNumber": {
				required: "Podaj numer domu",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"deliveryAddress.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"deliveryAddress.zipCode": {
				required: "Podaj kod pocztowy"
			},
			"deliveryAddress.city": {
				required: "Podaj nazwę miasta",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"delivery.localization":{
				required: ($('#delivery-points.type-inpost').length ? "Użyj wyszukiwarki aby wybrać Paczkomat®" : "Użyj wyszukiwarki aby wybrać punkt odbioru")
			},
			"delivery.parcelMachineCode":{
				required: "Wybierz Paczkomat®"
			},
			"delivery.pickupPointForm.dhlParcelPointCode":{
				required: "Wybierz punkt odbioru "
			},
			"delivery.pickupPointForm.postOfficeCode":{
				required: "Wybierz punkt odbioru"
			},
			"invoice.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"invoice.companyName": {
				required: "Podaj nazwę firmy",
				maxlength: "Pole może zawierać maksymalnie 160 znaków"
			},
			"invoice.street": {
				required: "Podaj nazwę ulicy",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"invoice.houseNumber": {
				required: "Podaj numer domu",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"invoice.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"invoice.zipCode": {
				required: "Podaj kod pocztowy"
			},
			"invoice.city": {
				required: "Podaj nazwę miejscowości",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"warrantyRegulationsReaded": {
				required: "Zapoznaj sie z warunkami ubezpieczenia"
			},
			"delivery.shopCode":{
				required: "Wybierz Punkt Odbioru Osobistego, w którym chcesz odebrać Towary",
				minlength:"Wybierz Punkt Odbioru Osobistego, w którym chcesz odebrać Towary"
			},
			"delivery.cityCode":{
				required: "Wybierz miejscowość, w której chcesz odebrać Towary",
				min:"Wybierz miejscowość, w której chcesz odebrać Towary"
			},
			"termsAccepted":{
				required: "Zapoznanie z Regulaminem jest wymagane"
			},
			"partnerSubscriptionsContactDetails.termsAccepted":{
				required: "Akceptacja zgody jest wymagana"
			},
			"partnerSubscriptionsContactDetails.firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"partnerSubscriptionsContactDetails.lastName": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"partnerSubscriptionsContactDetails.contactPhone":{
				required: "Podaj numer telefonu",
				phone: "Podaj poprawny nr telefonu"
			}
		}
	});

	// po dodaniu walidacji na formularz, odblokuj przycisk dalej
	$('#frontForm .js-next').removeClass('btn-disabled');

	// dodanie regul dla kazdego elementu input z atrybutem name
	// rozpoczynajacym sie od "insurance.insurerNameToReadStatus"
	$('[name^="insurance.insurerNameToReadStatus"]').each(function(index, element) {
		$(element).rules("add", {
			required: true,
			messages: {
				required: $(element).attr('data-input-type') == 'subscription_regulations'
					? 'Zapoznaj się z Regulaminem płatności cyklicznej'
					: 'Zapoznaj sie z warunkami ubezpieczenia'
			}
		});
	});
}



function deliveryStart(s){

	fancyRegulamin();
	deliveryValidate();
	permissions();

	$('#termsAccepted').click(function(){
		checkTermsAccepted('#termsAccepted');$('#frontForm').validate().element('#termsAccepted');
	});

	$('#email').keyup(function(){
			var em = $("#email").val();
			if( em!='' ) {
				$("#login").attr('readonly', true);
				$("#login").val(em);

			}else {
				$("#login").attr('readonly', false);
			}
	});

	$('#noEmail').click(function(){
		if($(this).is(':checked')){
			$('#email').ignore(true).attr("disabled", true).trigger('blur');
			$('#login').ignore(true).attr("disabled", true).trigger('blur');
			//$('#frontForm').validate().element($(this));
			$('#email').closest('.errorBox').removeClass('statusError');
			$('#login').closest('.errorBox').removeClass('statusError');
			//console.log("zaznacz fakture papierowa");
			if( $('.show-paper-invoice').is(':visible') ){
				showPaperInvoice();
				}
			$("#invoice").prop("checked", true);
			$("#current-permissions").hide().find("input:checkbox").prop('checked', false);
			$("#electronic-payment-unavailable").show();
		}else{
			$('#email').ignore(false).attr("disabled", false).trigger('keyup');
			$("#current-permissions").show();
			$("#electronic-payment-unavailable").hide();
		}
	});

	if(s=='home')toggleUserType();

	$("#realPhoneInput").keyfilter(/[\d\- ]/);
	$("#realPhoneInputDelivery").keyfilter(/[\d\- ]/);

	$(".zipCode").mask2("99-999");
	$(".zipCode").keyfilter(/[\d\-]/);
	nip();
	companyName('company-name');
	companyName('invoice-company-name');
	$(".pesel").unmask2().mask2("99999999999");
	$(".pesel").keyfilter(/[\d]/);
	autocompleteDelivery('zipCode', 'cityName', 'homeAddressStreet');

	regon({
		$box: $('#orderInvoiceNipBox .regon-box'),
		$nip: $('#orderInvoiceNip'),
		$companyName: $('#invoice-company-name-textarea-div'),
		$city: $('#invoiceCityName'),
		$street: $('#invoiceAddressStreet'),
		$houseNumber: $('#invoiceAddressHouseNumber'),
		$flatNumber: $('#invoiceAddressFlatNumber'),
		$zipCode: $('#invoiceZipCode')
	});
	regon({
		$box: $('#nipBox .regon-box'),
		$nip: $('#userNip'),
		$companyName: $('#company-name-textarea-div'),
		$city: $('#cityName'),
		$street: $('#homeAddressStreet'),
		$houseNumber: $('#homeAddressHouseNumber'),
		$flatNumber: $('#homeAddressFlatNumber'),
		$zipCode: $('#zipCode')
	});
	
	if ($.inArray(s, ['home', 'inpost', 'pickupPoints']) > -1) {
		HomeForm('');
		InvoiceForm('');
		ReceiverForm('');
		autocompleteDelivery('invoiceZipCode', 'invoiceCityName', 'invoiceAddressStreet');
		updateInvoiceData($('#defaultInvoiceId').val());
	}
	if(s=='home'){
		updateInvoiceData($('#defaultInvoiceId').val());
		autocompleteDelivery('deliveryZipCode', 'deliveryCityName', 'deliveryAddressStreet');
		updateDeliveryAddress($('#defaultDeliveyId').val());
	}
	if(s=='inpost'){
		
	}
	if(s=='pickupPoints') {
		
	}
	if(s=='shop' && $('#fakturaBox').length){
		autocompleteDelivery('invoiceZipCode', 'invoiceCityName', 'invoiceAddressStreet');
		fakturaChange();
	}
	if(s=='shop'){
		updateInvoiceData($('#defaultInvoiceId').val());
		$('.fastOrderPaymentType input.paymentType').click(function(){
			$('.fastOrderPaymentType .checked').removeClass('checked');
			$(this).parents('.row').addClass('checked');
		});
	}
	smallBasketBreakPrice();

	setTabIndex();
}
function smallBasketBreakPrice() {
	if($('#basket-small').length > 0) {
		$('#basket-small table .price a').each(function() {
			$(this).html($(this).text().replace(' x', '<br/>x'));
		});
	}
}

function saveServiceBox(itemId){
	$.fancybox.close();
	setTimeout(function(){
		loadingStart();
		$('#F_SELECTED_ITEM').val(itemId);
		$('#F_ACTION').val('UPDATE_SERVICES_QUANTITY');
		removeValidate();
		$('#cartForm')[0].submit();
	},300);
}

function promotedLayer(href){
	clearTimeout(hideTimer);
	container.css('display', 'none');
	$.fancybox({href:href},{
		width: 780,
		padding:0,
		height: 400,
		titleShow:false,
		type:'iframe'
	});
}

function cartStart(account){
	previewStart();
	deliveryTypeListInit();
	checkEsdDelayed();
	$('.delivery-type-list .item').click(function(){
		var input=$(this).find('input[name="deliveryType"]');
		if(!input.is(':disabled')){
			input.prop('checked',true)[0].click();
		}
	});
	instalmentTO();
	$('input.countService').keyfilter(/[\d]/);

	$('.serviceInfo, .service-info').on('click', function() {
		var rel = ($(this).attr('rel')) ? $(this).attr('rel') : $(this).attr('href').match(/\d*\s*\d+/)[0];
		$.fancybox($('.serviceText' + rel).html(), {
			autoDimensions: true,
			height: 'auto',
			padding: 0
		});
	});

	//koszyk ilość produktów/usług/gwarancji/akcesoriów
	//blokada wpisania innych znaków niż cyfry
	//blokada CTRL + V
	$('.filterNumbers').keyfilter(/\d/);
	$('body').on('paste', '.filterNumbers', function(e) {
		e.preventDefault();
	});
	$('.ratesInfo').mouseover(function(){
		showToolBox(this,$('.rates'+jQuery(this).attr('rel')+':eq(0)').html(),345);
	}).mouseleave(function(){
		closeToolBox();
	});

	$('.paymentInfo').mouseover(function(){
		showToolBox(this,$('.payment'+jQuery(this).attr('rel')+':eq(0)').html(),45);
	}).mouseleave(function(){
		closeToolBox();
	});

	$('tr.prod:odd').addClass('odd');
	$('tr.prod').each(function(){
		$(this).prev().children('td').not('.u').addClass('pB15');
	});
	$('.cart_summarize tr:last td').not('.u').addClass('pB15');
	$('.cart_summarize tr.small').each(function(){
		if(!($(this).next().hasClass('small')))$(this).children('.list').addClass('lastlist');
	});

	$('#insurerPayment').keyfilter(/[\d\,\.]/).keyup(function(){
		customerPaymentCalculate(false);
	}).blur(function(){
		setTimeout("customerPaymentCalculate(true);",100);
	});

	$('.radiogroup input:disabled').parent().children('jquery-safari-radio').css('opacity','0.3');
	$('.radiogroup input:disabled').parent().children('label').css('color','#7f7f7f');

	$('input.basic-product').click(function() {
		setTimeout(function() {
			calculateCart();
		}, 100);
	});

	$('tr .quantity input.int, .js-warranty-quantity').blur(function(){
		var maxQuantity = $(this).data('max')/1;
		var currentValue = $(this).val()/1;
		if (maxQuantity > 0 && currentValue > maxQuantity) {
			showMaxCountMessage(maxQuantity);
			$(this).val(tmpValue/1);
			return;
		}
		if($('#fancybox-content #cartMessageCheckWarranty').length !== 0){
			return;
		}
		if(!$(this).val()>0){
			$(this).val(tmpValue/1);
		}
		var newTmpValue=$(this).val();

		if($(this).attr('warrantiesMake')!='1'){
			if($(this).hasClass('partner-subscription-quantity')) {
				loadingStart();
				return $.ajax({
					url: '/cart-update-partner-subscription-quantity.ltr',
					method: 'POST',
					dataType: 'json',
					data: {
						partnerSubscriptionId: $(this).data('id'),
						productId : $(this).data('product-id'),
						quantity : $(this).val()
					},
					cache: false,
					complete: function(json) {
						if(json.responseJSON && json.responseJSON.status=='FAIL'){
							$.fancybox('<div class="w300"><div class="f14 bold tcenter">' + json.responseJSON.messages + '</div><div class="mT10 tcenter"><a class="btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Ok</a></div></div>', {
								autoDimensions: true,
								onClosed:function(){
									loadingReload();
								}
							});
						}else{
							calculateCart();
						}
					}
				});
			} else if($(this).hasClass('partner-subscription-standalone-service-quantity')) {
				loadingStart();
				return $.ajax({
					url: '/cart-update-partner-subscription-standalone-service-quantity.ltr',
					method: 'POST',
					dataType: 'json',
					data: {
						productId : $(this).data('product-id'),
						quantity : $(this).val()
					},
					cache: false,
					success: function(json) {
						if(json && json.status=='FAIL'){
							app.alert(json.messages, function(){
								loadingReload();
							});
						}else{
							calculateCart();
						}
					},
					error:function(){
						loadingStop();
						app.alert('Błąd zmiany ilości. Spróbuj ponownie');
					}
				});
			}
		}
		if(newTmpValue/1!=window.tmpValue/1){
			if(newTmpValue>window.tmpValue){
				try{
					$('#increasedItemId').val($(this).parents('tr').attr('id').substr(4));
				}catch(e){console.log('błąd increasedItemId');}
			}
			if($(this).closest('.prod').length){
				chceckWarrantiesCount(0, $(this).attr('id').substr(8));
			}else{
				calculateCart();
			}
		} else {
			if(cartType=='N' && newTmpValue/1!=window.tmpValue/1){
				if(newTmpValue>window.tmpValue){
					try{
					$('#increasedItemId').val($(this).parents('tr').attr('id').substr(4));
					}catch(e){console.log('błąd increasedItemId2');}
				}
				calculateCart();
			};
		}
	}).focus(function(){
		tmpValue=$(this).val();
	}).keyup(function(event){
		if(event.keyCode == 13){
			var maxQuantity = $(this).data('max')/1;
			var currentValue = $(this).val()/1;
			if (maxQuantity && currentValue > maxQuantity) {
				showMaxCountMessage(maxQuantity);
				$(this).val(tmpValue/1);
				return;
			}
			if($(this).hasClass('partner-subscription-quantity') || $(this).hasClass('partner-subscription-standalone-service-quantity') || !$(this).closest('.prod').length) {
				$(this).blur();
			} else {
				$(this).attr('warrantiesMake','1');
				chceckWarrantiesCount(1, $(this).attr('id').substr(8));
			}
		}
		if($(this).val()=='0')$(this).val(1);
	});
	$('.message').each(function(){
		if($(this).children().length==0)$(this).remove();
	});
	if(!account){
		addPrzelicz();

		if(cartType=='S'){
			$('.focusPrzelicz').change(function(){
				focusPrzelicz();
			}).click(function(){
				focusPrzelicz();
			}).focus(function(){
				focusPrzelicz();
			});
		}
		homeDeliveryPromotionMessage=$('#homeDeliveryPromotionMessage').parent().html();
		servicesNotSelected=$('#servicesNotSelected').parent().html();
		// notAddedServicesOnlyHomeDeliveryEncouragement=$('#notAddedServicesOnlyHomeDeliveryEncouragement').parent().html(); // => w euro

		$('#voucherInput').keyfilter(/[\da-zA-Z\.\-\_]/);

		$('.cart_summarize tr').each(function(){
			$(this).children(':first').addClass('bL0');
		});
	}else{
		$(".int").keyfilter(/[\d]/);
		$('.focusPrzelicz').focus(function(){
			$('#zastosujButton').fadeIn('normal');
		});
	}

	initialInstalmentCalculator();
}

function chceckWarrantiesCount(o, id = null) {
	if(id && $('#quantity'+id).val()>$('#warranty-item-'+id).val() && $('#warranty-item-'+id).val()>0){
		$('#cartMessageCheckWarrantyH').val(id)
		$.fancybox({
			href: '#cartMessageCheckWarranty',
			autoDimensions : true,
			onClosed:calculateCart
		});
		return false;
	}

	if(o==1)calculateCart();
	else{
		if(cartType=='N' && window.newTmpValue!=window.tmpValue){
			calculateCart();
		};
	}
	return true;
}




function hideNotifyDelivery(flag) {
	if (flag == 'true') {
		$('#HOMEDeliveryType').prop('checked', true);
		$('#POODeliveryType').prop('checked', false);
		$('#F_ACTION').val('CHANGE_DELIVERY_TYPE_AND_CREATE_ORDER');
	} else {
		$('#POODeliveryType').prop('checked', true);
		$('#HOMEDeliveryType').prop('checked', false);
		$('#F_ACTION').val('CREATE_ORDER');
	}
	loadingStart();
	removeValidate();
	$('#cartForm')[0].submit();
	$.fancybox.close();
}

function chceckWarrantiesMake(){
	var id=$('#cartMessageCheckWarrantyH').val();
	var v=$('#quantity'+id).val();
	$('#warranty-item-'+id).val(v);
	$('#F_ACTION').val('SAVE');
	removeValidate();
	$('#cartForm')[0].submit();
}

function instalment(){
	$("#frontForm").validate({
		rules:{
			"payment.instalmentShopCode": {
				required:true,
				minlength:2
			},
			"payment.instalmentCityCode": {
				required:true,
				min:1
			}
		},
		messages:{
			"payment.instalmentShopCode": {
				required:"Wybierz punkt OleOle! w którym chcesz odebrać Towary",
				minlength:"Wybierz punkt OleOle! w którym chcesz odebrać Towary"
			},
			"payment.instalmentCityCode": {
				required:"Wybierz miejscowość, w której chcesz odebrać Towary",
				min:"Wybierz miejscowość, w której chcesz odebrać Towary"
			}
		}
	});
}





function removeValidate(){
	$('#cartForm').find('input, select').addClass('ignore');
}
function deleteProduct(id,that){
	UA.removeFromCart($(that));
	if(needRefresh($('#md5Sum').val())) {
		return false;
	}
	removeValidate();
	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(id);
	$('#F_ACTION').val('DELETE_ITEM');
	$('#cartForm')[0].submit();
}
function deleteWarranty(id){

	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(id);
	$('#F_ACTION').val('DELETE_WARRANTY');
	removeValidate();
	$('#cartForm')[0].submit();
}
function deleteService(id, p){

	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(p);
	$('#F_SELECTED_SERVICE').val(id);
	$('#F_ACTION').val('DELETE_SERVICE');
	removeValidate();
	$('#cartForm')[0].submit();
}
function deleteServicePack(itemId){

	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(itemId);
	$('#F_ACTION').val('DELETE_SERVICE_PACK');
	removeValidate();
	$('#cartForm')[0].submit();
}
function zamawiam(){

	if(window.sessionStorage.getItem('operator-logged')==="true") {
		if(!updateWarrantyQuestionnaire()){
			return false;
		}
	}

	if(showInstalmentOrdersRequiringActionsForNextAction && $('#instalmentOrdersRequiringActions').length){
		instalmentOrdersRequiring();
		return false;
	}
	if(needRefresh($('#md5Sum').val())) {
		return false;
	}
	if(!$('input[name="deliveryType"]:checked').length){
		$('.order_navigate').addClass('error');
		$('.delivery-type-list').addClass('statusError');
		return false;
	}
	checkWarrantyUA();
	if (servicesInExcludedDeliveryEncouragement) {
		showServicesInExcludedDeliveryEncouragement('#servicesShopDelivery');
		return false;
	}

	if (showNotAddedServices){
		showNotAddedServicesToAdd();
		return false;
	}

	if (checkValues() && promoteHomeDelivery()) {
		setValue('F_ACTION', 'CREATE_ORDER');
		loadingStart();

		const $voucherInput = $('#voucherInput');
		const voucherCode = $voucherInput.val();
		const voucherCodeHasChagned =
			$voucherInput.prop('defaultValue') !== voucherCode;

		if (!voucherCodeHasChagned) {
			submitCartForm();
			return false;
		}

		if (voucherCode) {
			voucherService.applyVoucher(voucherCode).then(submitCartForm);
		} else {
			voucherService.removeVoucher().then(submitCartForm);
		}
	}
}

function submitCartForm() {
	$('#cartForm')[0].submit();
}

function dalejGo(){
	loadingStart();
	$('#F_ACTION').val('NEXT');
	$('#frontForm').submit();
}
function dalej(s){

	if($('#frontForm').valid()){

		if(typeof window.showHomeAddress != "undefined" && window.showHomeAddress==true)var showHomeAddress=true;
        else var showHomeAddress=false;

        if(typeof window.showInvoiceData != "undefined" && window.showInvoiceData==true)var showInvoiceData=true;
		else var showInvoiceData=false;

		var checkHomeAddress = (s=='S' && showHomeAddress==true && $('#zipCode').length && $('#zipCode').val()!='');
		var checkInvoiceAddress = (s=='S' && showInvoiceData==true && ($('#faktura:checked').length || $('#invoiceNeededI:checked').length) && $('#invoiceZipCode').length && $('#invoiceZipCode').val()!='');

		if(checkHomeAddress && checkInvoiceAddress) {
			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#cityName').val(),
					zipCode: $('#zipCode').val(),
					street: $('#homeAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: true,
					invoiceCityName: $('#invoiceCityName').val(),
					invoiceZipCode: $('#invoiceZipCode').val(),
					invoiceAddressStreet: $('#invoiceAddressStreet').val()
				},
				success: function(data) {
					var message = data.message;
					var isAnyProductESD = data.isAnyProductElectronicSoftwareDistribution === 'true';
					var isAddressValid = data.isAddressValid;
					var isInvoiceAddressValid = data.isInvoiceAddressValid;

					if (message != "") {
						if(!data.blockPaymentStep) {
							showModalAddressError(data, function(){validateServices()});
						} else {
							showModalBlockPayment(data);
						}
					}
					else {
						dalejGo();
					}
				}
			});
		} else if(checkHomeAddress && !checkInvoiceAddress){
			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#cityName').val(),
					zipCode: $('#zipCode').val(),
					street: $('#homeAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: false,
					invoiceCityName: '',
					invoiceZipCode: '',
					invoiceAddressStreet: ''
				},
				success: function(data) {

					var message = data.message;
					var isAnyProductESD = data.isAnyProductElectronicSoftwareDistribution === 'true';
					var isAddressValid = data.isAddressValid;
					var isInvoiceAddressValid = data.isInvoiceAddressValid;

					if (message != "") {
						if(!data.blockPaymentStep) {
							showModalAddressError(data, function(){validateServices()});
						} else {
							showModalBlockPayment(data);
						}
					}else {
						dalejGo();
					}
				}
			});

		} else if(!checkHomeAddress && checkInvoiceAddress){
			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#invoiceCityName').val(),
					zipCode: $('#invoiceZipCode').val(),
					street: $('#invoiceAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: false,
					invoiceCityName: '',
					invoiceZipCode: '',
					invoiceAddressStreet: ''
				},
				success: function(data) {

					var message = data.message;
					var isAnyProductESD = data.isAnyProductElectronicSoftwareDistribution === 'true';
					var isAddressValid = data.isAddressValid;
					var isInvoiceAddressValid = data.isInvoiceAddressValid;

					if (message != "") {
						if(!data.blockPaymentStep) {
							showModalAddressError(data, function(){validateServices()});
						} else {
							showModalBlockPayment(data);
						}
					}
					else {
						dalejGo();
					}
				}
			});
		}
		else{
			dalejGo();
		}
	}else{
		scrollToError();
	}
}

function gotoZipCode(invalidZipCodeSelector){
	$(invalidZipCodeSelector).focus();
	$.scrollTo(invalidZipCodeSelector,800);
}

function dalejD(){
	if($('#frontForm').valid()){
		loadingStart();
		if ($('#deliveryEqualsHome').is(':checked')) {
			deliveryAddressSwitch('true');
		}
		if ($('#otherPersonReceipt').is(':checked')) {
			receiverDataSwitch('true');
		}
		if ($('#invoiceNeeded').is(':checked')) {
			invoiceAddressSwitch('true');
		}

		var isDelivery = $('#deliveryEqualsHomeI').prop('checked');
		var isInvoice = $('#invoiceNeededI').prop('checked');

		$.ajax({
			url: '/order-path-validate-address-integrity.ltr',
			dataType: 'json',
			async: false,
			data: {
				cityName: $('#cityName').val(),
				zipCode: $('#zipCode').val(),
				street: $('#homeAddressStreet').val(),
				isDelivery: isDelivery,
				deliveryCityName: $('#deliveryCityName').val(),
				deliveryZipCode: $('#deliveryZipCode').val(),
				deliveryAddressStreet: $('#deliveryAddressStreet').val(),
				isInvoice: isInvoice,
				invoiceCityName: $('#invoiceCityName').val(),
				invoiceZipCode: $('#invoiceZipCode').val(),
				invoiceAddressStreet: $('#invoiceAddressStreet').val()
			},
			success: function (data) {

				var message = data.message;

				if (message != "") {
					if (!data.blockPaymentStep) {
						showModalAddressError(data, function () { validateServices() });
					} else {
						showModalBlockPayment(data);
					}
				}
				else {
					validateServices();
				}
			}
		});
	}else{
		scrollToError();
	}
}
function checkTermsAccepted(el){
	if($(el).hasClass('error') || $(el).hasClass('valid')){
		$('#frontForm').validate().element($(el));
		if($(el).hasClass("valid")) {
			$(el).closest(".errorBox").removeClass("statusError").addClass("statusOk");
		} else {
			$(el).closest(".errorBox").addClass("statusError").removeClass("statusOk");
		}
	}
}

function LastStageBeforFinalize(){
	var next=$('.order_navigate .dalej');
	if($('#nextButtonHtml').val()!=''){
		next.html($('#nextButtonHtml').val());
	}
}

function onShopSelect() {
	$('#cityCode').val($('#unityCityCode').val());
	$('#shopCode').val(0);
	$('.unity-shop-cities').html('<'+'div style="margin:0px auto;" class="pB10 pT10 ico-loading">'+'<'+'/div>');
	refreshShops($('#cityCode').val(), $('#shopCode').val(), false);
	$('#frontForm').validate().element('#cityCode');
}


function setShopCode(code){
	$('#shopCode').val(code);
	$('#frontForm').validate().element('#shopCode');
	$.scrollTo($('.order_navigate'),300);
}





function selectPaymentTypeInCart(paymentType) {
	paymentType=paymentType/1;
	console.log("nr platnosci " + paymentType);

	$('.order_navigate').removeClass('error').removeClass("error-payment").removeClass("error-tpay").removeClass("error-saved-bank");$('.order_navigate').removeClass('error');
	$('.paymentLeft').attr('li',paymentType);

	var numerInput = '#row' +  paymentType;
	if ($('.paymentLeft').find( numerInput ).prop('disabled') == true) {
		return; // przerwij jesli niezalogowany lub input z ktorego pochodzi zdarzenie jest w trybie disabled
	}

	if(paymentType==3){
		showETransferRegulation();
	}
	else {
		hideETransferRegulation();
	}

	if(paymentType==2){
		$('#transfer-payment-type').show();
	}
	else {
		$('#transfer-payment-type').hide();
	}

	toggleWarrantySubscriptionPaymentMessage(paymentType);

	if(paymentType==12){
		//$('#frontForm')[0].reset();
		$('#address-reminder').show();
		$('#ePaymentBankBluemedia, #instalment-checkbox1, #instalment-checkbox2').ignore(false);
		$('#invalid-promotion-message').show();
	}
	else{
		$('#address-reminder').hide();
		$('#ePaymentBankBluemedia, #instalment-checkbox1, #instalment-checkbox2').ignore(true);
		$('#invalid-promotion-message').hide();
	}
	if(paymentType==5){
		$('.lastStage').removeClass('zamawiam').addClass('rezerwuje');
	}else{
		$('.lastStage').removeClass('rezerwuje').addClass('zamawiam');
	}
	if(paymentType==5){
		$('#shopCode').ignore(false);
		$('#cityCode').ignore(false);
		$('#ePaymentBank').ignore(true);
		$('#unity-shop-chooser').show();
		$('#ePaymentBanks').hide();
		if($('#unity-shop-chooser .shopsItem').length){

		}else{
			shops.refreshShops();
		}
	}else if(paymentType==3){ console.log("platnosc 3 i operator payU!");
		$('#shopCode').ignore(true);
		$('#cityCode').ignore(true);
		$('#ePaymentBank').ignore(false);
		$('#ePaymentBanks').show();
		$('#unity-shop-chooser').hide();
	}else {
		$('#shopCode').ignore(true);
		$('#cityCode').ignore(true);
		$('#ePaymentBank').ignore(true);
		$('#ePaymentBanks').hide();
		$('#unity-shop-chooser').hide();
	}
}

function checkPaymentHeight(){
	var h1=$('.paymentLeft').height();
	var h2=$('.paymentRight .text').height();
	var h=Math.max(h1,h2);
	$('.paymentRight .text').css('min-height',h);
}

//dawniej instalment
function orderPaymentValidation(){
	$("#frontForm").validate({
		rules:{
			"payment.instalmentShopCode": {
				required:true,
				minlength:2
			},
			"payment.instalmentCityCode": {
				required:true,
				min:1
			},
			"ePaymentBank":{
				required:true,
				minlength:1
			},
			"ePaymentBankBluemedia":{
				required:true,
				minlength:1
			},
			"termsAccepted":{
 				required: true
			},
			"instalment-checkbox1":{
				required:true
			},
			"instalment-checkbox2":{
				required:true
			}
		},
		messages:{
			"payment.instalmentShopCode": {
				required:"Wybierz sklep, w którym chcesz odebrać Towary",
				minlength:"Wybierz sklep, w którym chcesz odebrać Towary"
			},
			"payment.instalmentCityCode": {
				required:"Wybierz miejscowość, w której chcesz odebrać Towary",
				min:"Wybierz miejscowość, w której chcesz odebrać Towary"
			},
			"ePaymentBank":{
				required: "Wybierz bank"
			},
			"termsAccepted":{
				required: "Akceptacja regulaminu jest wymagana"
			},
			"ePaymentBankBluemedia":{
				required: "Wybierz bank, w którym posiadasz internetowe konto osobiste"
			},
			"instalment-checkbox1":{
				required: "Ten warunek jest konieczny aby przejść do kolejnego etapu zamówienia"
			},
			"instalment-checkbox2":{
				required: "Ten warunek jest konieczny aby przejść do kolejnego etapu zamówienia"
			}
		},
		errorPlacement: function(error, element){
			if(element.attr("name")=="ePaymentBank"){
				ePaymentBankErrorPlacementValidation(error, element);
			}else{
				errorPlacementValidation(error, element);
			}
		}
	});
}


function startPayment(){

	var $selectedBank = $('#ePaymentBanks .ePaymentBankIco').filter('.selected');
	if($selectedBank.length) {
		previousPaymentOperator = $selectedBank.data('operator');
	}

	orderPaymentValidation();
	//console.log("start payment");

	if(typeof paymentTypeCode !== 'undefined'){
		$('div.row'+paymentTypeCode).addClass('activ');
		$('.paymentLeft .row').append('<'+'div class="rog"><'+'/div>');

		var li=$('.paymentLeft .row'+paymentTypeCode+' label').not(".radio-css").attr('id');
		if(li) {
			$('.paymentLeft').attr('li',li.substr(0,li.length-1));
		}
		if(paymentTypeCode != '5'){
			$('#ShopCode').ignore(true);
			$('#CityCode').ignore(true);
		}
		if(paymentTypeCode == '3'){
			var bankName = $("#ePaymentBanks .ePaymentBankIco.selected").find(".ePaymentBankLogo").attr("alt");
			addChoosenBankName(bankName);
			showETransferRegulation();
			$('#ePaymentBanks').show();
		}

		toggleWarrantySubscriptionPaymentMessage(paymentTypeCode);

		if(paymentTypeCode == '12'){
			$('#invalid-promotion-message').show();
		} else {
			$('#invalid-promotion-message').hide();
		}

		try{
			$('.paymentLeft').attr('li',$('.paymentLeft .activ input').attr('id').substr(3));
		}catch(e){}
	}else{
		/*setTimeout(function(){
			showMessage($('.paymentLeft label:first').attr('for').substr(3));
		},200);*/
	}
	$('.paymentLeft .row label').not(".radio-css").wrap('<div class="fleft pT2 pL5"/>');
	$('.paymentLeft input:disabled').parent().css('opacity',0.5);

	$('.paymentLeft .row').mouseenter(function(){
			var id=$(this).find('input.paymentType').attr('id').substr(3);
			showMessage(id);
	}).mouseleave(function(){
		showMessage($('.paymentLeft').attr('li'));
	});
	$('.paymentLeft').mouseleave(function(){
		showMessage($('.paymentLeft').attr('li'));
	})
	setTimeout("replaceLabelPayment(4);",100);
	setTimeout("replaceLabelPayment(0);",100);
	setTimeout("checkPaymentHeight();",200);

}
function replaceLabelPayment(id){
	if($('.paymentLeft .row'+id+' label').length){
		$('.paymentLeft .row'+id+' label').not(".radio-css").html($('.paymentLeft .row'+id+' label').not(".radio-css").html().replace("(","<br />("));
	}
}
/**
 * lastOrderShopCode - kod sklepu, ktory zostal ostatnio wybrany jako miejsce
 * dostarczenia zamowionego towaru
 */


function unityShopChooser(){

	$('#unity-shop-chooser .shopsItem:visible').each(function(){
		$(this).children('.checkbox').css('padding-top', parseInt(($(this).height()-20)/2));
	});
}

function showMessage(show) {
	//console.log(show);
	if(typeof show == 'undefined'){
		if(paymentTypeCode){
			showMessage(paymentTypeCode);
			return;
		}
		$('.paymentRight').hide();
		$('.default-paymentRight').show();
		$('.row.activ').removeClass('activ');
	}
	else {
		$('.paymentRight').show();
		$('.default-paymentRight').hide();
		if (show == 6)$('#peselInstalmentToHome').show();
		else $('#peselInstalmentToHome').hide();

		$('.paymentRight .out').not('.div'+show).hide();
		$('.div'+show).show();

		$('.paymentLeft .row').removeClass('activ');
		$('.paymentLeft .row'+show).addClass('activ');
		/*if(show == 14) {
			$('.paymentRight .top').addClass('masterpass');
		} else {
			$('.paymentRight .top').removeClass('masterpass');
		}*/
		checkPaymentHeight();
	}
}



function setCurrent() {
	$('#currentTime').css("display","block");
}

function giftCardAmountToCoverByCashSet(){
	//puista funkcja dla ole
}

var hoverOffTime=false;
function hoverOffGridTable(){
	hoverOffTime=setTimeout(function(){
		$('#gridPreview').css('visibility','hidden');
	},300);
}

var gridCount=0;
function gridDeliveryStart(){
	$('#container').after('<div id="gridPreview"><div class="top"></div><div class="middle"></div><div class="bottom"></div></div>');
	$('#gridPreview').hover(function(){
		clearTimeout(hoverOffTime);
	},function(){
		hoverOffGridTable();
	});
	if($('table.grid').length){
		grid1();
	}
	if($('.deliveryDayList').length){
		grid2();
	}
	if($('#order-delivery-time-confirm').length) {
		var div = $('.order_navigate .rezerwuje, .order_navigate .dalej, .order_navigate .zamawiam, .order_navigate .zlozWniosek');
		var checkbox = $('#order-delivery-time-confirm');
		if (!checkbox.is(':checked')) {
			div.addClass('time-confirm');
		}
		checkbox.click(function(){
			var that=$(this);
			setTimeout(function(){
				if(that.is(':checked')){
					div.removeClass('time-confirm');
					if($('.deliveryCostToAccept .errorBox').hasClass('statusError')){
						$('.deliveryCostToAccept .errorBox').removeClass('statusError').addClass('statusOk');
					}
				} else {
					div.addClass('time-confirm');
				}
			}, 50);
		});
	}
}

function grid2(url){
	if(test.getVar('delivery_payment')) {
		UA.interaction('TestAB','ab_deliverypayment',test.getVar('delivery_payment'));
	}
	$('.deliveryDayList .active a').click(function(){
		$('.order_navigate').removeClass('error');
		var hover=$(this).parents('.deliveryDayList').find('.hover').removeClass('hover');
		var input=$(this).addClass('hover').find('input[type="radio"]');
		input.prop('checked',true);
		$('#deliveryKindDescriptions .deliveryKindDescription').hide();
		$('#deliveryKindDescriptions #deliveryKindDescription-'+$(this).attr('rel')).show();
		loadTimeAndServices(input.val(),url,$(this).find('input').val());
	});
	$(document).mousemove(function(e){
		if(gridCount==0){
			$('.active > a').hover(function(){
				clearTimeout(hoverOffTime);
				hoverOnGrid2($(this));
			},function(){
				clearTimeout(hoverOffTime);
				hoverOffGridTable();
			});
		}
		gridCount++;
	});
	showDefaultTooltip();
	$('.deliveryDayList .active input').click(function(){
		$(this).parents('a')[0].click();
	});
	if($('.deliveryDayList .active input:checked').length){$('.deliveryDayList .active input:checked')[0].click();}
}

function loadTimeAndServices(id,url,dayIndex){
	loadingStart();
	if(!url){
		url='/order-path-orderDeliveryTimeIntervals.ltr';
	}
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url:url,
		cache : false,
		async:false,
		data:{
			dayIndex:id
		},
		success: function (html) {
			if (html.indexOf('timeDeliveryList') > -1) {
				$('#loadTimeAndServicesList').html(html);
				checkbox('#loadTimeAndServicesList');
				loadingStop();
				var selectedInterval = $('#loadTimeAndServicesList input:checked');
				if (selectedInterval.length) {
					selectedInterval.trigger('click');
				} else {
					if ($('#basket-small').length) {
						updateSlectedDeliveryTimeDay(dayIndex);
					} else {
						$('#row3').hide();
					}
				}
				$('#loadTimeAndServicesList ul.group li').hover(function () {
					clearTimeout(hoverOffTime);
					hoverOnGrid2($(this), $(this).find('.popup').html());
				}, function () {
					clearTimeout(hoverOffTime);
					hoverOffGridTable();
				});
				_orderDeliveryTimeIntervalsEvents();
			} else {
				fancyOk('Wystąpił błąd wybierania dnia dostawy. Prosimy spróbować później lub skontaktować się z obsługą.');
			}
		}
	});
}

function checkMasterpassTermAccepted(input){
	if( $(input).prop("checked") ){
		$('.order_navigate').removeClass('error3');// + error?
	}
	else{
		$('.order_navigate').addClass('error3');
	}
}

function updateSlectedDeliveryTimeInterval() {

	$('.order_navigate').removeClass('error error1 error2');
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url: '/order-path-time-select-interval.ltr',
		cache: false,
		dataType : 'json',
		type: 'POST',
		data: {
			selected_interval: $('#selected_interval').val(),
			refresh: true
		},
		success: function(json){
			if($('#selected_interval').val()!=0){
				$('#row4').hide();
				$('#row3').show();
				$('#deliveryPrice').text($('#mainOrderDeliveryPrice').text());
			}else{
				$('#row4').show();
				$('#row3').hide();
			}
			standardCartPreviewForOrderPathSuccess(json);
		}
	});
}

function updateSlectedDeliveryTimeDay(dayIndex) {
	$('.order_navigate').removeClass('error error1 error2');
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url: '/order-path-time-select-day.ltr',
		cache: false,
		dataType : 'json',
		type: 'POST',
		async: false,
		data: {
			dayIndex: dayIndex,
			refresh: true
		},
		success: function(json){
			standardCartPreviewForOrderPathSuccess(json);
			$('#row4').hide();
			$('#row3').show();
			$('#deliveryPrice').text($('#mainOrderDeliveryPrice').text());
		}
	});
}

function hoverOnGrid2(that,html){
	if(that.length){
		hoverOffTime=setTimeout(function(){
			var tooltipHtml = html;
			if(!tooltipHtml) tooltipHtml=that.next().html();
			var position=that.offset();
			$('#gridPreview').find('.middle').html(tooltipHtml);
			$('#gridPreview').css({
				top:position.top-$('#gridPreview').height()+5,
				left:position.left+5
			});
			//clearTimeout(hoverOffTime);
			$('#gridPreview').css('visibility','visible');
		}, 500);
	}
}

function hoverOnGridTable(that){
	if(that.length){
		hoverOffTime=setTimeout(function(){
			var position=that.offset();
			$('#gridPreview').find('.middle').html(that.find('.gridDate').html());
			$('#gridPreview').css({
				top:position.top-$('#gridPreview').height()+5,
				left:position.left+5
			});
			//clearTimeout(hoverOffTime);
			$('#gridPreview').css('visibility','visible');
		}, 500);
	}
}
function clickGridTable(that){
	that.parents('table').find('.hover').removeClass('hover');
	that.addClass('hover');
	var parent=that.parent('tr').find('td.col1').addClass('hover');
	that.parents('table').find('th').eq(that.data('i')).addClass('hover');
	if(that.find('input').length && !that.find('input:checked').length){
		that.find('input:checked')[0].click();
	}
}


function addCartServices(id){
	var data={
		mainItemId:id,
		servicesIds:[],
		addedFrom:'CART_EDIT'
	};
	$('#service'+id+' tr').each(function(){
		if($(this).find('input.checkbox:checked').length){
			var serwis=$(this).find('input.idService').val();
			if(serwis>0){
				data.servicesIds.push(serwis);
			}
		}
	});
	if(data.servicesIds.length){
		loadingStart();
		$.ajax({
			url:'/add-services-to-cart.ltr',
			type:'POST',
			data:data,
			cache:false,
			success:function(){
				reloadCartView();
			},error:function(){
				fancyOk('Wystąpił błąd dodawania usługi. Prosimy spróbować później lub skontaktować się z obsługą.');
			}
		});
	}else{
		$.fancybox(servicesNotSelected,{
			padding:0,
			autoDimensions:	true
		});
	}
}
function changeServiceCount(idProduct, idService){
	var input=$('#serviceCount'+idProduct+'_'+idService);
	var max=input.attr('size')/1;
	var quantity = parseInt(input.val()/1);
	if (quantity == 0){
		input.val(1);
	}
	if(max<quantity){
		input.val(max);
	}
}



function showNotAddedServicesToAdd(){
	var option = {
			autoDimensions : true,
			onComplete : function() {
				$.fancybox.resize();
				setServiceInfo('#fancybox-content');
				var form=$('#fancybox-content #serviceToAddReminderFrom');
				form.find('.noSafari').removeClass('noSafari');
				checkbox('#fancybox-content');
				form.find('.zamowDoDomu, .dalej2').click(function() {
					setValue('F_ACTION', 'CREATE_ORDER');
					submitCartForm();
					loadingStart();
					$.fancybox.close();
				});
				form.find('.bezWniesienia').click(function() {
					var checkedServices=[];
					form.find('.servicesCheckbox input:checked').each(function(){
						checkedServices.push($(this).val());
					})
					form.find('#serviceToAddReminderFromAction').val('REMOVE_SELECTED_SERVICES');
					form.find('#itemsWithServices').val(checkedServices.join(','));
					form.submit();
					$.fancybox.close();
				});

				form.find('.bezWniesienia').mouseover(function(){
					showToolBox(this,$('.artContent'+jQuery(this).attr('rel')).html(),65,{bottom:10, smallClass:true});
				}).mouseleave(function(){
					closeToolBox();
				});
				form.find('.zamowDoDomu, .js-tooltip').mouseover(function(){
					showToolBox(this,$('.artContent'+jQuery(this).attr('rel')).html(),25,{smallClass:true});
				}).mouseleave(function(){
					closeToolBox();
				});
			}

	};
	// $.fancybox({href:'#serviceToAddReminder'}, option);
	sendServiceEvent($('#serviceToAddReminder input[name="eventTypeName"]').val());
	$.fancybox($('#serviceToAddReminder')[0].outerHTML, option);
}

var shops={
		cityCode:0,
		shopCode:0,
		zipCode:'',
		hasOnlySmall:false,
		lastOrderShopCode:'',
		location:'delivery',
		paddingTop:function(){
			$('#unity-shop-chooser .shopsItem:visible').each(function(){
				$(this).children('.checkbox').css('padding-top', parseInt(($(this).height()-20)/2));
			});
		},
		showAllCities:function(){
			$('#showAllCities').hide();
			$('#selectShopDiv .citySelectBox').show();
			$('#unity-shop-chooser').removeClass('oneItem').addClass('manyItems');
			$('#selectShopDiv .shopsItem').addClass('bT').slideDown();
		},
		setShopCode:function(code,city){
			this.shopCode=code;
			if(city && city!=''){
				$('#cityCode').val(city);
				this.cityCode=city;
			}
			$('#selectShopDiv .citySelectBox').hide();

			$('#showAllCities').show();
				$('#selectShopDiv .shopsItem').not($('#radio'+code).closest(".shopsItem")).hide();
				$('#unity-shop-chooser').addClass('oneItem');
			$('#shopCode').val(code);
			try{
				$('#frontForm, #paymentForm').validate().element('#shopCode');
			}catch(e){

			}
		},
		hideCitiefastOrder:function(){
			if($('#unity-shop-chooser input:checked').length==1 && this.zipCode==''){
				$('#unity-shop-chooser input:checked')[0].click();
			}
		},
		refreshShops:function(option){
			var that=this;
			if(!/\d{2}\-\d{3}/.test(this.zipCode)){
				this.zipCode='';
			}

			var orderNumber = $('#shopForOrderNumber').val();
			var shopsListLocation = $('#shopsListLocation').val();

			var data={
				city: this.cityCode,
				store_code: this.shopCode,
				zipCode:this.zipCode,
				location: this.location,
				filtered: this.hasOnlySmall,
				lastOrderShopCode: this.lastOrderShopCode
			};

			if (orderNumber != "" && typeof orderNumber != "undefined") {
				data.orderNumber = orderNumber;
				data.location = shopsListLocation;
			}
			if(option && option.location){
				data.location = option.location;
			}
			if(option && option.paymentType){
				data.paymentType = option.paymentType
			}
			if(this.cityCode!='')$.cookie('userCity',this.cityCode,{expires: 30, path:'/'});
			if(this.zipCode!='')$.cookie('userCity',this.zipCode,{expires: 30, path:'/'});
			$.extend({}, data, option);
			var async=true;
			if($('#paymentForm').length){
				async=false;
			}
			$.ajax({
				url:'/orderSelectShop.ltr',
				async:async,
				method:'get',
				data: data,
				success: function(html){
					$('#unity-shop-chooser').removeClass('loading').html(html);
					$('#zip_code_select').mask2('99-999').keyup(function(event){if(event.keyCode == 13)shops.onZipCodeSelect();});
					$('#unity-shop-chooser select').combobox();

					checkbox('#unity-shop-chooser');
					$('#unity-shop-chooser .errorBox').errorBox();

					that.paddingTop();

					if($('#unity-shop-chooser .checkbox input').length==1){
						var input=$('#unity-shop-chooser .checkbox input:first');
						input.prop('checked',true);
						that.setShopCode(input.val(),$('#unityCityCode').val());
					}else{
						that.hideCitiefastOrder();
					}
					if(data.zipCode!='' && $('#unity-shop-chooser .checkbox').length>3 && !$('#unity-shop-chooser .checkbox input:checked').length){
						$('#showAllCities').show();
						$('#selectShopDiv .citySelectBox').hide();
						$('#selectShopDiv .shopsItem:gt(2)').hide();
						$('#selectShopDiv .shopsItem:eq(0)').removeClass('bT');
					}
				},
				error:function(){
					app.alert('Bład podczas generowania listy sklepów. Odśwież stronę i spróbuj ponownie')
				}
			});
		},
		showOtherShops:function() {
			$('#unity-shop-chooser').removeClass('oneItem');
			$('#shopHeader').text('Wybierz sklep');
			$('#cityCode').ignore(false);
			$('#selectShopDiv').show();
			$('#lastOrderShopDiv').remove();
			this.paddingTop();
		},
		prepareRefreshShop:function(options){
			$('.unity-shop-cities').html('<'+'div style="margin:0px auto;" class="pB10 pT10 ico-loading">'+'<'+'/div>');
			this.refreshShops(options);
			if($('#cityCode').parents('.statusError').length)$('#frontForm').validate().element('#cityCode');
		},
		onZipCodeSelect :function(){
			$('#unityCityCode').removeAttr('onchange').unbind('change focus select keyup click keydown').val('');
			this.onShopSelect();
		},
		onShopSelect:function(value){
			if($('#zip_code_select').val()!='' && $('#unityCityCode').val()==''){
				this.zipCode=$('#zip_code_select').val();
				this.cityCode=0;
			}else if($('#unityCityCode').val()!='' && $('#zip_code_select').val()==''){
				this.cityCode=$('#unityCityCode').val();
				this.zipCode='';
			}else if(value){
				this.cityCode=value;
				this.zipCode='';
			}else{
				this.cityCode='';
			}

			this.shopCode='';
			this.prepareRefreshShop();
		}
	};
function fakturaChange(){
	if($('#faktura').attr('checked') || warranty){
		$('#faktura1').val('true');
		$('#fakturaBox').show().find('input').ignore(false);
		toggleUserType();
	}else{
		$('#fakturaBox').hide().find('input').ignore(true);
		$('#faktura1').val('false');

	}
}

function showServicesPack(id){
	if($('#servicesPackLayer_'+id).length) {
	$.fancybox($('#servicesPackLayer_'+id).html(),{
		autoDimensions:	true,
		onComplete:function(){
			$('#fancybox-content input:text').keyfilter((/[\d]/));
			setServiceInfo('#fancybox-content');
		}
	});
	}
}

function ePaymentBankValidation(){
	if($("#ePaymentBanks").length > 0){
		$('#cartForm').validate({
			rules:{
				"ePaymentBank":{
					required:true,
					minlength:1
				}
			},
			messages:{
				"ePaymentBank":{
					required: "Wybierz bank"
				}
			}
		});
	}
}


function addChoosenBankName(name){
	if(typeof name != "undefined" && name != ''){
		$("#ePaymentBanks .errorBox h2").html(ePaymentChoosenBankTxt+name);
	}
}
function setEPaymentBank(id, name, obj){
	$('#ePaymentBank').val(id);
	addChoosenBankName(name);
	$('#ePaymentBanks .ePaymentBankIco').removeClass('selected');
	obj.addClass('selected');
	$('#frontForm').validate().element("#ePaymentBank");
	showETransferRegulation();
	$('#tpay-bank-list input:radio').prop('checked', false);
	updatePaymentBank(id)
}

function openAddSourceParam(form) {

	$.fancybox({href: '/add-source-param.ltr?operator_form=' + form},
			{
				autoDimensions : true
			}
	);
}



function retrieveCartQuestion(message) {
	$.fancybox('<div class="w300"><div>'+message+'</div><div class="mT10 buttonA"><div class="w190"><a class="tak fleft" href="javascript:void(0);" onclick="retriveCart();$.fancybox.close();"></a><a class="nie fleft" href="javascript:void(0);" onclick="$.fancybox.close();"></a><div class="clear"></div></div></div></div>',{autoDimensions:true,hideOnOverlayClick:false});
}
